import { ReactComponent as TadaIcon } from "assets/images/tada.svg"
import LinkContainer from "components/shareable/LinkContainer";
import MainConfetti from "components/shareable/Confetti";
import Colors from "modules/Colors";
import ModalSymphony from "elements/ModalSymphony";
import { CSSProperties } from "react";
import { clsx } from "modules/Utils";

interface PublishedWebsiteModalProps {
    className: string;
    style?: CSSProperties;
    isOpen: boolean
    websiteUrl: string
    onClose: () => void
    onClickViewWebsiteAnalytics: () => void
}

const PublishedWebsiteModal = ({
    className,
    style,
    isOpen,
    websiteUrl,
    onClose,
    onClickViewWebsiteAnalytics,
}: PublishedWebsiteModalProps) => {
    return (
        <ModalSymphony
            className={clsx('publishedWebsiteModalComponent', className)}
            style={style}
            isOpen={isOpen}
            onClose={onClose}
            headerIcon="tada"
            title="Your website has been published!"
            subtitle="You can come back and view stats in realtime from the Dashboard and edit styling at any time. Here's your website link, share it with the world:"
            buttonRightText="View Website Analytics"
            buttonRightClassName="viewWebsiteAnalyticsButton"
            onClickButtonRight={onClickViewWebsiteAnalytics}
        >
            <LinkContainer
                url={websiteUrl}
                showShareButton
                showEditButton={false}
                width="100%"
                padding="8px 16px"
                buttonTextColor={Colors.purpleLight}
                backgroundColor={Colors.DARK_DIVIDER_LINE}
                textColor={Colors.textColor}
            />
            <MainConfetti
                numberOfPieces={600}
            />
        </ModalSymphony>
    );
}

const sty: Record<string, CSSProperties> = {
}

export default PublishedWebsiteModal